import { gql } from '@generated/gql';

const addressSearch = gql(`
  query AddressSearch($postCode: String!) {
    addressSearch(postCode: $postCode) {
      addresses {
        id
        uprn
        organisation
        department
        subBuilding
        buildingName
        buildingNumber
        thoroughfare
        dependentThoroughfare
        dependentLocality
        doubleDependentLocality
        postTown
        county
        postcode
      }
    }
  }
`);

export { addressSearch };
